import React from "react";
import "./DoubtTabs.css";

const DoubtTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="doubt-tabs">
      <button
        className={activeTab === "all" ? "active" : ""}
        onClick={() => setActiveTab("all")}
      >
        All Doubts
      </button>

      <button
        className={activeTab === "your-doubts" ? "active" : ""}
        onClick={() => setActiveTab("your-doubts")}
      >
        Your Doubts
      </button>

      <button
        className={activeTab === "your-answer" ? "active" : ""}
        onClick={() => setActiveTab("your-answer")}
      >
        Your Answer
      </button>
    </div>
  );
};

export default DoubtTabs;
